
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { debugLogger } from "@/utils/debugLogger";

export const useEmailVerification = () => {
  const [isVerifying, setIsVerifying] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleEmailVerification = async () => {
    const hash = window.location.hash;
    
    if (hash && hash.includes('access_token')) {
      debugLogger.log('AUTH', 'Email verification process started', { hash });
      setIsVerifying(true);
      
      try {
        // Parse the hash to get the access token
        const accessToken = hash.substring(1).split('&').find(param => param.startsWith('access_token='))?.split('=')[1];
        
        if (accessToken) {
          debugLogger.log('AUTH', 'Setting auth session with access token');
          // Set the auth session using the access token
          const { data, error } = await supabase.auth.setSession({ 
            access_token: accessToken, 
            refresh_token: '' 
          });
          
          if (error) {
            throw error;
          } else {
            toast.success("Email verified successfully! You're now logged in.");
            debugLogger.log('AUTH', 'Email verification successful, navigating to /cms');
            
            // Only use setTimeout to avoid Supabase deadlocks
            setTimeout(() => {
              navigate('/cms');
            }, 0);
          }
        }
      } catch (error: any) {
        debugLogger.log('AUTH', 'Email verification failed', { error: error.message });
        toast.error(error.message || "Failed to verify email");
      } finally {
        setIsVerifying(false);
      }
    }
  };

  return {
    isVerifying,
    handleEmailVerification
  };
};
